import React, { useEffect } from "react";
import update from "immutability-helper";

import DropdownMenu from "../Dropdown.jsx";
import REACT_TABLE_FILTER_STORAGE_KEY from './Table.jsx';

const useFilterOptions = (filterOptions, autoDetect, { preFilteredRows, id }) => {
  // Calculate the options for filtering
  // using the preFilteredRows
  return React.useMemo(() => {
    if (autoDetect) {
      let options = {};
      preFilteredRows.forEach((row) => {
        if (row.values[id]) {
          if (Array.isArray(row.values[id])) {
            // If value is an array, add each entry as an option
            row.values[id].forEach((v) => {
              options[v] = { value: v, label: v };
            });
          } else {
            options[row.values[id]] = { value: row.values[id], label: row.values[id] };
          }
        }
      });
      // Sort options alphabetically by label
      return Object.values(options).sort((a, b) => a.label.toString().localeCompare(b.label));
    }

    return filterOptions;
  }, [id, preFilteredRows, filterOptions, autoDetect]);
};

// Filter component to be used in column definitions for the Table component
export const ColumnFilter = ({
  filterOptions = [],
  includeBlank,
  column,
  initialFilter,
  autoDetectOptions = false,
  iconOnly = false,
  storeFilter = false,
  ...rest
}) => {
  const { filterValue = [], setFilter, id } = column;

  useEffect(()=>{
    if(initialFilter){
      setFilter(initialFilter);
    }
  }, [])
  const toggleOption = (e, value) => {
    const { checked } = e.target;
    const updatedValue = update(
      filterValue,
      checked
        ? {
            $push: [value],
          }
        : (values) => values.filter((v) => v != value)
    )
    
    if(storeFilter){
      const key = `${REACT_TABLE_FILTER_STORAGE_KEY}_${window.location.pathname}`;
      // All filters stored
      const item = localStorageWithExpiry.getItem(key) ? localStorageWithExpiry.getItem(key) : [];
      const index = item.findIndex((i) => i.id==id);
      // All filters after update
      const filters = index == -1 ? item.concat([{id: id, value:updatedValue}]) : update(item, {[index]: {value: {$set: updatedValue}}}) 
      localStorageWithExpiry.setItem(key, filters);
    }

    setFilter(updatedValue);
  };

  const options = useFilterOptions(filterOptions, autoDetectOptions, column);

  const close = (e) => {
    e.preventDefault();
  };

  const clear = (e) => {
    setFilter([]);
    e.preventDefault();
  };

  return (
    <DropdownMenu
      linkAsToggle
      btnClass={`toggle ${filterValue.length ? "active" : ""}`}
      label={
        <span>
          <i className="icon icon-filter"></i> {iconOnly ? "" : I18n.t("filter")}
        </span>
      }
      containerClass="column-filters"
      classes="pt-0 pb-1"
      hideOnClick={false}
      {...rest}
    >
      <div className="filter-values">
        {[...options, ...(includeBlank ? [{ label: `[${I18n.t("none")}]`, value: null }] : [])].map(
          (o, i) => (
            <label key={i} className="item">
              <input
                type="checkbox"
                checked={filterValue.includes(o.value)}
                onChange={(e) => toggleOption(e, o.value)}
              />
              {o.label}
            </label>
          )
        )}
      </div>
      <div className="filter-actions">
        <a
          href="#"
          className="done pull-right btn btn-xs btn-primary mr-1"
          onClick={close}
          data-close-dropdown="true"
        >
          {I18n.t("done")}
        </a>
        <a href="#" className="clear pull-right btn btn-xs btn-default mr-1" onClick={clear}>
          {I18n.t("clear")}
        </a>
      </div>
    </DropdownMenu>
  );
};

export default ColumnFilter;